 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Reinsurance
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryRiFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12 md6>
                          <v-text-field
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersRi.polNo"
                            :label="filtersRiLabel.polNo"
                            :error-messages="errors.collect('filterRi')"
                            data-vv-name="filterRi"
                            :data-vv-as="filtersRiLabel.policy"
                            v-validate="'entry|max:20|min_char:3'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12 md6>
                          <v-autocomplete
                            :items="riTypeList"
                            v-model="filtersRi.riType"
                            :label="filtersRiLabel.riType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="filterRi"
                            :data-vv-as="filtersRiLabel.riType"
                            :error-messages="errors.collect('filterRi')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearRiFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doRiFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="riHeaders"
          :items="riItems"
          v-bind:options.sync="paginationRi"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsRi"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignRi(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { riFilters } from '@/mixins/reinsurance/riFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationRi: {
        page: 1
      }
    }
  },
  mounted() {
    this.doClearRiFilters()
  },
  methods: {
    closeDialog() {
      this.filtersRi.polNo = ''
      this.filtersRi.riType = ''
      this.$emit('close')
    },
    doClearRiFilters() {
      this.filtersRi.polNo = ''
      this.filtersRi.riType = ''
      this.fetchRiOutwardsHelpListData()
    },
    doRiFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryRiFilterForm').then((result) => {
        if (result) {
          this.paginationRi.page = 1
          this.fetchRiOutwardsHelpListData()
        }
      })
    },
    assignRi(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-ri', data.polNo)
      this.$emit('close')
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearRiFilters()
      }
    }
  },
  computed: {},
  mixins: [TableConst.default, riFilters, commonAjaxMixin],
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  }
}
</script>
